var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamplingSegmentationDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3002 2.3C16.8752 2.725 16.8752 12.275 17.3002 12.7C17.5252 12.925 19.2252 13 23.4002 13C29.8752 13 29.9252 12.975 29.6752 11.35C29.2252 8.6 26.5002 4.975 23.7752 3.525C21.3252 2.225 18.0002 1.6 17.3002 2.3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0252 6.40001C4.70021 8.10001 0.775212 14.675 2.37521 20.875C4.05021 27.275 10.6002 31.25 16.8252 29.625C19.5002 28.925 22.7502 26.825 22.7502 25.775C22.7502 25.55 21.0002 23.625 18.8752 21.5L15.0002 17.625V12.125C15.0002 8.15001 14.9252 6.52501 14.7002 6.30001C14.3002 5.90001 12.7002 5.95001 11.0252 6.40001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 15.3C17.125 15.475 17 15.775 17 16C17 16.5 25.275 24.75 25.775 24.75C26.35 24.75 27.85 23.025 28.625 21.525C29.8 19.175 30.375 15.975 29.7 15.3C29.275 14.875 17.725 14.875 17.3 15.3Z",
    fill: "#1B1F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamplingSegmentationDark);
export default __webpack_public_path__ + "static/media/Sampling&SegmentationDark.117d7eaf3084b38565d1da03fc4cd6e8.svg";
export { ForwardRef as ReactComponent };